import Quill from 'quill'

interface BlotConstructor {
  create(value?: unknown): HTMLElement
  scope: unknown
  new (...args: unknown[]): {
    domNode: HTMLElement
    format(name: string, value: unknown): void
  }
}

const BaseImageFormat = Quill.import('formats/image') as BlotConstructor
const ImageFormatAttributesList = ['alt', 'height', 'width', 'style', 'class']

class CustomImageBlot extends BaseImageFormat {
  static blotName = 'image'

  static tagName = 'IMG'

  static formats(domNode: HTMLElement) {
    return ImageFormatAttributesList.reduce(
      (formats: Record<string, string | null>, attribute: string) => {
        if (domNode.hasAttribute(attribute)) {
          formats[attribute] = domNode.getAttribute(attribute)
        }
        return formats
      },
      {}
    )
  }

  format(name: string, value: unknown) {
    if (ImageFormatAttributesList.indexOf(name) > -1) {
      if (value) {
        this.domNode.setAttribute(name, String(value))
      } else {
        this.domNode.removeAttribute(name)
      }
    } else {
      super.format(name, value)
    }
  }
}

export default CustomImageBlot
